/**
 * Ingredient Categorization System
 * Maps ingredient names to store categories for organized shopping lists
 */
// Keyword-based categorization
const categoryKeywords = {
    "Produce": [
        "onion", "garlic", "tomato", "potato", "carrot", "celery", "pepper", "bell pepper",
        "lettuce", "spinach", "kale", "broccoli", "cauliflower", "cabbage", "mushroom",
        "zucchini", "squash", "cucumber", "avocado", "lemon", "lime", "orange", "apple",
        "banana", "berries", "strawberry", "blueberry", "raspberry", "herbs", "parsley",
        "cilantro", "basil", "thyme", "rosemary", "ginger", "scallion", "shallot", "leek"
    ],
    "Meat & Seafood": [
        "chicken", "beef", "pork", "turkey", "lamb", "steak", "ground beef", "ground turkey",
        "bacon", "sausage", "ham", "fish", "salmon", "tuna", "shrimp", "crab", "lobster",
        "tilapia", "cod", "halibut", "mussels", "clams", "scallops"
    ],
    "Dairy & Eggs": [
        "milk", "cream", "heavy cream", "half and half", "butter", "cheese", "cheddar",
        "mozzarella", "parmesan", "feta", "goat cheese", "yogurt", "sour cream",
        "cream cheese", "eggs", "egg whites", "egg yolks"
    ],
    "Bakery": [
        "bread", "buns", "rolls", "bagels", "tortillas", "pita", "baguette", "croissant"
    ],
    "Pantry": [
        "flour", "sugar", "brown sugar", "rice", "pasta", "noodles", "quinoa", "couscous",
        "oats", "cereal", "beans", "lentils", "chickpeas", "oil", "olive oil", "vegetable oil",
        "coconut oil", "vinegar", "balsamic", "soy sauce", "worcestershire", "hot sauce",
        "ketchup", "mustard", "mayonnaise", "honey", "maple syrup", "jam", "jelly",
        "peanut butter", "almond butter", "broth", "stock", "bouillon", "tomato sauce",
        "tomato paste", "canned tomatoes", "corn", "peas", "baking powder", "baking soda",
        "yeast", "cornstarch", "breadcrumbs", "panko", "crackers", "chips", "nuts",
        "almonds", "walnuts", "pecans", "cashews", "seeds", "sunflower seeds", "chia seeds"
    ],
    "Frozen": [
        "frozen vegetables", "frozen fruit", "frozen berries", "ice cream", "frozen pizza",
        "frozen meals", "frozen peas", "frozen corn", "frozen spinach", "frozen broccoli"
    ],
    "Spices & Seasonings": [
        "salt", "pepper", "black pepper", "paprika", "cumin", "chili powder", "oregano",
        "cinnamon", "nutmeg", "cloves", "cardamom", "turmeric", "curry powder", "bay leaf",
        "cayenne", "red pepper flakes", "garlic powder", "onion powder", "vanilla extract",
        "almond extract", "seasoning", "italian seasoning", "herbs de provence"
    ],
    "Beverages": [
        "water", "juice", "coffee", "tea", "soda", "beer", "wine", "liquor", "vodka",
        "rum", "whiskey", "gin", "tequila"
    ],
    "Other": []
};
/**
 * Categorize an ingredient by matching keywords
 */
export function categorizeIngredient(ingredientName) {
    const lowerName = ingredientName.toLowerCase();
    for (const [category, keywords] of Object.entries(categoryKeywords)) {
        for (const keyword of keywords) {
            if (lowerName.includes(keyword)) {
                return category;
            }
        }
    }
    return "Other";
}
/**
 * Get all categories in display order
 */
export function getAllCategories() {
    return [
        "Produce",
        "Meat & Seafood",
        "Dairy & Eggs",
        "Bakery",
        "Pantry",
        "Frozen",
        "Spices & Seasonings",
        "Beverages",
        "Other"
    ];
}
/**
 * Get emoji icon for category
 */
export function getCategoryIcon(category) {
    const icons = {
        "Produce": "🥬",
        "Meat & Seafood": "🍖",
        "Dairy & Eggs": "🥛",
        "Bakery": "🍞",
        "Pantry": "🥫",
        "Frozen": "❄️",
        "Spices & Seasonings": "🧂",
        "Beverages": "🥤",
        "Other": "📦"
    };
    return icons[category];
}
